export const setAddressItem = (address) => {
  const {
    firstname,
    lastname,
    city: addressCity,
    postcode: addressPostcode,
    street,
    telephone: phone,
  } = address.reverse()[0]

  return {
    firstname,
    lastname,
    addressCity,
    addressHouseNumber: street?.[1],
    addressPostcode,
    addressStreet: street?.[0],
    phone,
  }
}
